import { render, staticRenderFns } from "./batch-payout-reference-list.vue?vue&type=template&id=b6f88768&scoped=true"
import script from "./batch-payout-reference-list.vue?vue&type=script&lang=js"
export * from "./batch-payout-reference-list.vue?vue&type=script&lang=js"
import style0 from "./batch-payout-reference-list.vue?vue&type=style&index=0&id=b6f88768&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f88768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6f88768')) {
      api.createRecord('b6f88768', component.options)
    } else {
      api.reload('b6f88768', component.options)
    }
    module.hot.accept("./batch-payout-reference-list.vue?vue&type=template&id=b6f88768&scoped=true", function () {
      api.rerender('b6f88768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/batch-payout-reference-list.vue"
export default component.exports